/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GrowthGalleryDto } from '../../models/growth-gallery-dto';

export interface GrowthGalleryControllerTogglePublic$Params {
  id: string;
}

export function growthGalleryControllerTogglePublic(http: HttpClient, rootUrl: string, params: GrowthGalleryControllerTogglePublic$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthGalleryDto>> {
  const rb = new RequestBuilder(rootUrl, growthGalleryControllerTogglePublic.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GrowthGalleryDto>;
    })
  );
}

growthGalleryControllerTogglePublic.PATH = '/api/growth-galleries/{id}/toggle-public';
